import { render } from "./SourceList.vue?vue&type=template&id=2d8ee8f6&scoped=true"
import script from "./SourceList.vue?vue&type=script&lang=js"
export * from "./SourceList.vue?vue&type=script&lang=js"

import "./SourceList.vue?vue&type=style&index=0&id=2d8ee8f6&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8ee8f6"]])

export default __exports__